import ReactDOM from 'react-dom/client';
import React from 'react';
import { v2Component } from '../../../index';
import { TenantContext } from '../../../context/tenant-context';
import { StripeContextProvider } from '../../../context/stripe-context';
import StripePaymentAuthorization from './payment-authorization';

export function initOrderAuthentication() {
  const elements = document.getElementsByName('order-auth-component');
  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');

      const root = ReactDOM.createRoot(element);
      const bootstrap = (mutations: MutationRecord[]) => {
        if (mutations.length === 0 || mutations.find((r) => r.attributeName === 'data-price')) {
          const { tenant, contextPath, orderId, ...rest } = Object.assign({}, element.dataset) as any;
          const props = {
            ...rest,
          };

          root.render(
            v2Component(
              <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
                <StripeContextProvider>
                  <StripePaymentAuthorization orderId={orderId} contextPath={contextPath} {...props} />
                </StripeContextProvider>
              </TenantContext.Provider>,
            ),
          );
        }
      };

      const observer = new MutationObserver(bootstrap);
      observer.observe(element, { attributes: true });
      bootstrap([]);
    }
  });
}
